jQuery(document).ready(function($) {
  if(document.getElementById('page-publicacao-legal')){
    //code goes down here

    const ul = document.getElementById("datas");
    const items = Array.from(ul.getElementsByTagName("li"));

// remove duplicates
    const filteredItems = items.reduce((accumulator, item) => {
      const filter = item.getAttribute("data-filtro");
      if (!accumulator.some((a) => a.getAttribute("data-filtro") === filter)) {
        accumulator.push(item);
      }
      return accumulator;
    }, []);

// sort by date in decreasing order
    filteredItems.sort((a, b) => {
      const [aMonth, aYear] = a.getAttribute("data-filtro").split("/");
      const [bMonth, bYear] = b.getAttribute("data-filtro").split("/");
      return new Date(bYear, bMonth - 1) - new Date(aYear, aMonth - 1);
    });

// update item text
    filteredItems.forEach(function (item) {
      const [month, year] = item.getAttribute("data-filtro").split("/");
      const formattedMonth = new Intl.DateTimeFormat("pt-br", { month: "long" })
        .format(new Date(year, month - 1))
        .replace(/^\w/, (c) => c.toUpperCase());
      const formattedYear = year;
      item.innerText = `${formattedMonth} ${formattedYear}`;
    });

// clear list and append sorted items
    ul.innerHTML = "";
    filteredItems.forEach((item) => {
      ul.appendChild(item);
    });

    ul.style.display= "";



//code goes up here
  }});
